import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value", "placeholder"];
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NumberInput',
    props: {
        modelValue: {},
        emptyZero: { type: Boolean, default: true },
        min: {},
        max: {},
        placeholder: { default: '0' }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const inputEl = ref(null);
        const props = __props;
        const emits = __emit;
        /**
         * Using a ref to enforce a re-render,
         * ensures that the value updates even without a real change to the value, e.g. from 0 to 0
         */
        const updateEnforcer = ref(0);
        /**
         * The actual value that is displayed in the input
         */
        const displayedNumber = ref(formatNumber(props.modelValue));
        watch(() => props.modelValue, (newVal) => {
            displayedNumber.value = formatNumber(newVal);
        });
        function validateValue(value) {
            let validValue = value;
            if (typeof props.min !== 'undefined' && props.min != null) {
                validValue = Math.max(validValue, +props.min);
            }
            if (typeof props.max !== 'undefined' && props.max != null) {
                validValue = Math.min(validValue, +props.max);
            }
            return validValue;
        }
        function formatNumber(value) {
            updateEnforcer.value++;
            return typeof value === 'number' && value ? value : '';
        }
        function onFocusOut(event) {
            const newVal = validateValue(+(inputEl.value?.value || 0));
            emits('update:modelValue', newVal);
            displayedNumber.value = formatNumber(newVal);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("input", _mergeProps({
                type: "number",
                ref_key: "inputEl",
                ref: inputEl,
                value: _ctx.emptyZero ? displayedNumber.value : _ctx.modelValue,
                key: _ctx.emptyZero ? updateEnforcer.value : ''
            }, _ctx.$attrs, {
                onFocusout: onFocusOut,
                placeholder: _ctx.placeholder
            }), null, 16, _hoisted_1));
        };
    }
});
